import Typewriter from "typewriter-effect"
import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
  Icon,
  useColorModeValue,
  createIcon,
  Image
} from '@chakra-ui/react';
import Contact from './Contact';
import Projects from './Projects';
import Github from "./github";
import Skills from "./Skills";
import About from "./About";

export default function Home() {
  return (
    <>
     
     
      <Container maxW={'8xl'} style={{display:"flex",gap:"3rem",justifyContent:"center"}} id="home"  height={{md:"80vh",base:"50vh"}}  backgroundImage={
          'url(https://media.istockphoto.com/id/1094922834/vector/binary-background.jpg?s=612x612&w=0&k=20&c=OEGamSEXekm5Q0dRGa1U4DtzgIS_Zq1cCjhjM3D0EWI=)'
        }
        backgroundSize={'cover'}
        backgroundPosition={'center center'}>
      <Box mt="2rem" style={{display:"flex",gap:"3rem",justifyContent:"center", height:"100vh"}}> 
      
        <Stack

          as={Box}
          textAlign={'start'}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 20, md: 36 }}>
            
          <Heading
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}
            marginTop="-30px"
            color={"white"}>
            Hi There! 
            
         <br />
            <Text as={'span'} color={'blue.400'}>
              I am Sonia Saini
            </Text>
            <Typewriter options={{
              autoStart: true,
              loop: true,
              color:"white",
              delay: 40,
              strings: [
                "Full-Stack Developer.",
                "Problem Solver.",
                "Tech Lover."
              ]
            }}/>
          </Heading>
         
         
        </Stack>
        </Box>
      </Container>
     <About/>
      <Projects/>
      <Github/>
      <Skills/>
      <Contact/>
    </>
  );
}

